import constants from "./constants";
import { createReducer, updateObject } from "../../utils/reduxHelper";

const initialState = {
  loginLoading: false,
  loginSuccess: false,
  loginError: null,
};

/**
 *  Login
 */
const loginBegin = state => updateObject(state, { loginLoading: true });
const loginSuccess = state =>
  updateObject(state, {
    loginLoading: false,
    loginError: null,
    loginSuccess: true,
  });
const loginFailure = (state, action) =>
  updateObject(state, { loginLoading: false, loginError: action.payload });

const handlers = {};
handlers[constants.LOGIN_BEGIN] = loginBegin;
handlers[constants.LOGIN_SUCCESS] = loginSuccess;
handlers[constants.LOGIN_FAILURE] = loginFailure;

const loginReducer = createReducer(initialState, handlers);

export default loginReducer;



// WEBPACK FOOTER //
// ./src/modules/login/reducer.js